import styled from "@emotion/styled";
import { Card } from "@mui/material";

export const CartItemWrapper = styled(Card)<{ isEdit: boolean }>(({ theme, isEdit }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	minHeight: "120px",
	color: theme.project.colors.fontColors.main,
	padding: "0 32px",
	borderRadius: "unset",
	display: "grid",
	alignItems: "center",
	columnGap: "10px",
	gridTemplateColumns: isEdit ? "4fr 1fr 2fr 1fr 1fr 1fr" : "24px 4fr 2fr 1fr 1fr 1fr",
	[theme.breakpoints.down("md")]: {
		padding: "16px",
		gridTemplateColumns: isEdit ? "minmax(0, 1fr)" : "24px minmax(0, 1fr)",
		rowGap: "12px",
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
		"& > div, & > button": {
			minWidth: 0,
			overflowWrap: "anywhere",
			wordBreak: "break-word"
		},
		"& > .desktop-image": {
			order: 1,
			flex: "0 0 auto"
		},
		"& > .desktop-qty": {
			order: 2,
			flex: "1 1 auto",
			display: "flex",
			alignItems: "center",
			justifyContent: "flex-start",
			marginLeft: "24px"
		},
		"& > .desktop-price": {
			order: 3,
			flex: "1 1 100px",
			display: "flex",
			alignItems: "center",
			gap: "8px"
		},
		"& > .desktop-ext-price": {
			order: 4,
			flex: "1 1 120px",
			display: "flex",
			alignItems: "center",
			gap: "8px"
		},
		"& > .desktop-remove": {
			order: 5,
			marginLeft: "auto"
		}
	}
}));

export const LineItemNumber = styled.p({
	placeSelf: "start",
	margin: "28px 0 0"
});

export const CartItemSku = styled.p(({ theme }) => ({
	...theme.project.typography.heading.h6,
	fontWeight: 400,
	margin: 0,
	fontsize: "34px"
}));
export const CartItemDescription = styled.p(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle1
}));

export const Thumbnail = styled.img({
	height: "81px",
	width: "100px",
	objectFit: "contain",
	display: "block"
});
